"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var colors = {
  orange: '#F28000',
  orangeDark: '#F99230',
  gray: '#4a4a4a',
  grayDark: '#e5e5e5',
  grayLight: '#f6f6f6',
  grayLighter: '#d2d2d2',
  grayLighterMax: '#f9f9f9',
  grayMedium: '#999',
  green: '#10ce64',
  white: '#FFF',
  clear: '#FFF',
  red: '#FF4444'
};
var _default = exports["default"] = colors;